<template>
<div>
  <div class="col-md-12">
    <canvas height="250" id="vehicle-chart"></canvas>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js'
export default {
  name: 'bookingSuccess',
  data() {
    return {
      loading: false,
      chartData: [],
      labelData: []
    };
  },
  watch:{
  },
  mounted() {
  },
  created(){
    this.loadData()
  },
  methods:{ 
    async loadData() {
      try {
        var vehicles = await this.$store.dispatch("get_vehicle_count")
        this.labelData = ["Available", "Booked", "Under Service", "Not Working"]
        var av = 0
        var bk = 0
        var us = 0
        var ous = 0
        var nw = 0
        vehicles.forEach(x=> {
          if (x.available != null) av+= x.available
          if (x.booked != null) bk+= x.booked
          if (x.underService != null) us+= x.underService
          if (x.ongoingUnderservice != null) ous+= x.ongoingUnderservice
          if (x.not_working != null) nw+= x.not_working
        })
        this.chartData = [av, bk, (us + ous), nw]
      } finally {
        const ctx = document.getElementById('vehicle-chart');
        var sourceChartFailure = {
          type: 'bar',
          data: {
            labels: this.labelData,
            datasets: [
              {
                data: this.chartData,
                backgroundColor:'rgba(75, 192, 192, 0.2)',
                borderColor:'rgb(54, 162, 235)',
                borderWidth: 2
              },
            ]
          },
          options: {
            legend: {
              display: false
            },
          },
        }
        new Chart(ctx, sourceChartFailure);
      }
    }
  },
  computed:{}
};
</script>

<style></style>